import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalDataService } from './local-data.service';
import { delay } from 'rxjs/operators';

const HTTP_STATUS_OK = 200; // todo: import these from somewhere
const HTTP_STATUS_BAD_REQUEST = 400;

@Injectable()
export class LocalApiService implements HttpInterceptor {


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.production) {
      return next.handle(request);
    }

    const PAGE_SIZE = 20;

    if (!request.url.startsWith('//example.com/')) {
      return next.handle(request);
    } else {
      const response = handleRoute(request.url); // new HttpResponse({status: 200, body: responseData});
      const ob = of(response);
      // // todo: delay
      return ob.pipe(delay(500));
    }


    // route handlers
    function handleRoute(path: string): HttpResponse<any> {
      if (path.endsWith('users')) {
        return listUsers();
      }

      const lockUserPathRE = /.*\/users\/(.+)\/lock/;
      if ((lockUserPathRE.test(path))) {
        const cn = path.match(lockUserPathRE)[1]; // other way round as test...
        return lockUser(cn);
      }

      const pwResetPathRE = /.*\/users\/(.+)\/password/;
      if ((pwResetPathRE.test(path))) {
        // todo: verify POST
        const cn = path.match(pwResetPathRE)[1]; // other way round as test...
        return resetUserPassword(cn);
      }

      const userPathRE = /.*\/users\/(.+)/;
      if ((userPathRE.test(path))) {
        const cn = path.match(userPathRE)[1]; // other way round as test...
        return findUser(cn);
      }

      // else
      return new HttpResponse({status: 404});
    }

    function listUsers() {
      const searchTerm = request.params.get('search');
      const ouFilter = request.params.get('ou');
      const page = +request.params.get('page');
      let users = LocalDataService.users();

      if (ouFilter !== null) {
        users = users.filter(
          user => (user.ou.toLowerCase() === ouFilter.toLowerCase()),
        );
      }

      if (searchTerm !== null) {
        users = users.filter(
          user => user.mail.toLowerCase().includes(searchTerm.toLowerCase()),
        );
      }

      // adapt local data to new api naming conventions
      users = users.map(
        user => {
          return {
            cn: user.id,
            ou: user.ou,
            displayName: user.firstName + ' ' + user.lastName,
            mail: user.email,
            careerTitle: user.department,
          };
        });

      // we now have the users we want, let's paginate

      const total = users.length;
      const offset = (page - 1) * PAGE_SIZE;
      users = users.slice(offset, offset + PAGE_SIZE);

      const body = {
        total: total,
        pageSize: PAGE_SIZE,
        currentPage: page,
        result: users,
      };

      return new HttpResponse({status: HTTP_STATUS_OK, body: body});
    }


    function findUser(cn: string) {
      const user = LocalDataService.users().find(iUser => iUser.id === cn);
      return new HttpResponse({status: HTTP_STATUS_OK, body: {result: user}});
    }

    function resetUserPassword(cn: string) {
      // todo: check if user exists
      const errors = {};
      if (!request.body.hasOwnProperty('newPassword')) {
        errors['newPassword'] = 'Please specify a new password!';
      }

      if (request.body.newPassword.length < 3) {
        errors['newPassword'] = 'Password too short';
      }

      if (Object.keys(errors).length > 0) {
        const errorBody = {
          status: HTTP_STATUS_BAD_REQUEST,
          errors: errors,
          message: 'Invalid password reset request',
        };
        return new HttpResponse({status: HTTP_STATUS_BAD_REQUEST, body: errorBody});
      } else { // success
        const successBody = {
          status: HTTP_STATUS_OK,
          errors: {},
          message: 'Reset OK',
        };
        return new HttpResponse({status: HTTP_STATUS_OK, body: successBody});
      }
    }

    function lockUser(cn: string) {
      return new HttpResponse({
          status: HTTP_STATUS_OK,
          body: {
            status: HTTP_STATUS_OK, message: 'Lock OK', errors: {},
          },
        },
      );
    }

  }
}

